export default __webpack_public_path__ + "static/media/meme-generator.df7801b0.jpg";